<template>
  <v-row no-gutters>
    <v-col cols="9" class="_pr-">
      <ColorPickerV2 title="Cor do ingresso" :colorSelected="selectedSection" type="item-background-color" /> 
    </v-col>
  </v-row>
</template>

<script>
import ColorPickerV2 from '../../../../_v2/ui/ColorPickerV2.vue'

export default {
  name: 'Layout1',
  components: {ColorPickerV2},
  props: {
    selectedSection: {type: Object, required: true}
  }    
}
</script>